import { FC } from 'react';
import styles from './home.module.scss';
import { Overview } from '../../modules/components/overview/overview';
import { Helmet } from 'react-helmet-async';

export const Home: FC = () => {
	return (
		<article className={styles.wrapper}>
			<Helmet>
				<title>Manifesto - Overview</title>
			</Helmet>
			<Overview />
		</article>
	);
};
